/* HeroStack — three floating cards in the hero visual:
   Theo, OpenCharts, and the wider OpenInsurance suite. The
   first two cards anchor to their on-page sections; the third
   surfaces the other suite products that are powered by Theo
   AI but live outside this page. */

const PRODUCT_CARDS = [
  {
    id: 'TH',
    href: '#product-theo',
    name: 'Theo',
    color: 'var(--theo-a)',
    num: 'AI',
    lbl: 'Engine powering reasoning, generation, and workflow execution',
    meta: 'Engine',
  },
  {
    id: 'OC',
    href: '#product-charts',
    name: 'OpenCharts',
    color: 'var(--charts)',
    num: '5',
    lbl: 'Flowcharts, presentations, vibe coding, podcasts, notes',
    meta: 'Workspace',
  },
];

/* OpenInsurance brand orange — pulled from the suite icon
   (#FF3904). Mirrors openinsurance.ai's accent palette. */
const SUITE_COLOR = '#FF3904';
const SUITE_PRODUCTS = [
  'CRM',
  'Euclid',
  'TomorrowLife',
  'OpenInsuranceOS',
  'ExclusionGuard',
];

function ProductCard({ card }) {
  return (
    <a
      className="stack-card"
      href={card.href}
      aria-label={`Jump to ${card.name} section`}
    >
      <div className="scard-head">
        <div
          className="scard-dot"
          style={{
            background: `${card.color}1f`,
            color: card.color,
            border: `1px solid ${card.color}55`,
          }}
        >
          {card.id}
        </div>
        <div className="scard-name">{card.name}</div>
        <div className="scard-meta">{card.meta}</div>
      </div>
      <div className="scard-num" style={{ color: card.color }}>{card.num}</div>
      <div className="scard-label">{card.lbl}</div>
      <svg className="scard-spark" viewBox="0 0 280 30" preserveAspectRatio="none">
        <path
          d="M0 22 L20 18 L40 20 L60 12 L80 14 L100 8 L120 11 L140 5 L160 9 L180 4 L200 7 L220 3 L240 6 L260 2 L280 5"
          stroke={card.color}
          strokeWidth="1.5"
          fill="none"
        />
        <path
          d="M0 22 L20 18 L40 20 L60 12 L80 14 L100 8 L120 11 L140 5 L160 9 L180 4 L200 7 L220 3 L240 6 L260 2 L280 5 L280 30 L0 30 Z"
          fill={card.color}
          opacity="0.12"
        />
      </svg>
    </a>
  );
}

function SuiteCard() {
  return (
    <a
      className="stack-card stack-card--suite"
      href="https://openinsurance.ai/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="See the rest of the OpenInsurance suite"
    >
      <div className="scard-head">
        <div
          className="scard-dot scard-dot--icon"
          style={{
            background: `${SUITE_COLOR}1f`,
            border: `1px solid ${SUITE_COLOR}55`,
          }}
        >
          <img
            src="/assets/openinsurance-icon.svg"
            alt=""
            width="20"
            height="20"
            style={{ display: 'block' }}
          />
        </div>
        <div className="scard-name">Suite</div>
        <div className="scard-meta" style={{ color: SUITE_COLOR }}>OpenInsurance</div>
      </div>
      <div className="scard-suite-list">
        {SUITE_PRODUCTS.map((p) => (
          <span
            key={p}
            className="scard-suite-pill"
            style={{
              borderColor: `${SUITE_COLOR}55`,
              color: SUITE_COLOR,
              background: `${SUITE_COLOR}10`,
            }}
          >
            {p}
          </span>
        ))}
      </div>
      <div className="scard-suite-footer">
        <span
          className="scard-suite-pip"
          style={{ background: SUITE_COLOR, boxShadow: `0 0 8px ${SUITE_COLOR}` }}
        />
        Powered by Theo AI
      </div>
    </a>
  );
}

export default function HeroStack() {
  return (
    <>
      {PRODUCT_CARDS.map((c) => (
        <ProductCard key={c.id} card={c} />
      ))}
      <SuiteCard />
    </>
  );
}
